<mh-alerts-wrapper>

  <section mhFilterBar>
    <div mhFilterGroup>
      <div>
        <mh-core-lib-datepicker
          [currentDates]="currentDates"
          [currentFilter]="currentFilterDate"
          (datepickerUpdated)="handleDatepickerUpdated($event)">
        </mh-core-lib-datepicker>
      </div>
      <mh-box-element *ngIf="fidelityPermissions.includes('interchain_followup_summary_result')">
        <mh-core-lib-filter-chain-zone [productId]="productId" [multipleSelectionMode]="true" (chainChanged)="setChain($event)"
          [disabled]="!isReady"></mh-core-lib-filter-chain-zone>
      </mh-box-element>
      <mh-core-lib-filter-hotels 
        [chainFilter]="originalChainFilter" 
        [multipleSelectionMode]="true" 
        (hotelsChanged)="handleHotelsChange($event)"
        [disabled]="isHotelsFilterDisabled">
      </mh-core-lib-filter-hotels>  
      <mh-core-lib-survey-wrapper *ngIf="shouldShowSurveyWrapper" [productId]="productId" [chain]="chainFilter" [listenCustomerSubscribe]="false" [multipleSelectionMode]="true"
        (currentSurveySetted)="onSurveysLoaded($event)"
        #surveyWrapper></mh-core-lib-survey-wrapper>
    </div>
    
    <div>
      <mh-filter-date [startDate]="startDate" [endDate]="endDate" [type]="'summary'" [persistDate]="false"
        [report]="fidelityPermissions.includes('interchain_followup_summary_report') ? report : null "
        [reportActiveEmail]="true" [checkPermissions]="true" [slug]="reportSlug"></mh-filter-date>
    </div>
  </section>

  <ng-container *ngIf="shouldShowSummary">
    <mh-followup-summary-widgets
      [chainFilter]="chainFilter"
      [productId]="productId"
      [currentDates]="currentDates"
      [currentFilterDate]="currentFilterDate"
      [surveysReady]="surveysReady"
      [chain]="chain"
      [fidelityPermissions]="fidelityPermissions"
      (loadingStateChange)="onLoadingStateChange($event)">
    </mh-followup-summary-widgets>
  </ng-container>

</mh-alerts-wrapper>
